type FullAddressParams = {
  street?: string | null
  city?: string | null
  state?: string | null
  zipCode?: string | null
  country?: string | null
}
export const fullAddress = (params: FullAddressParams) => {
  const { street, city, state, zipCode } = params
  let address = ``
  address = street ? `${street}, ` : address
  address = city ? `${address} ${city}, ` : address
  address = state ? `${address} ${state} ` : address
  address = zipCode ? `${address} ${zipCode}` : address
  return address
}
